import React from "react"
import menu from "../data/menu.json"
import { withPrefix } from "gatsby"

export default function DownloadFullReport({ className }) {
  const downloads = menu.find(item => {
    return item.name === "Downloads"
  }).children
  const downloadLink = downloads.find(item => {
    return item.name === "Download Full Report"
  })
  const reports = downloads.find(item => {
    return item.name === "Download Full Report"
  }).children

  return reports ? (
    <div className="download-full-report">
      <h4 className="title--quaternary">Download Full Report</h4>
      <ul className={className}>
        {reports.map((item, index) => (
          <li key={index}>
            <a href={withPrefix("/") + item.href}>{item.name}</a>
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <a href={withPrefix("/") + downloadLink.href} className="title--quaternary">
      {downloadLink.name}
    </a>
  )
}
